import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

export const Slider = ({ children, settings = {}, className }) => {
    const sliderOptions = {
        slidesPerView: 1,
        pagination: true,
        navigation: false,
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 10000,
        },
        ...settings,
    };

    return (
        <Swiper {...sliderOptions} className={className} modules={[Autoplay]}>
            {children}
        </Swiper>
    );
};

export { SwiperSlide as Slide };
